module.exports = __webpack_public_path__ + "img/nucleo-icons.0b8a30b1.svg";